import { makePaymentsGetRequest } from 'utils/api'

import moment from 'moment-timezone'
import { utcCurrentDate, timezoneDate } from 'utils/helpers'

const createStripePortal = async () => {
  const result = await makePaymentsGetRequest('/v1/customer-portal')
  return result
}

export const redirectToStripePortal = async (stripeConfig, stripeId, stripeUrls) => {
  const data = await createStripePortal(stripeConfig, stripeId, stripeUrls)

  window.open(data.url, '_blank')
}

export const isFreeTrial = trialEndDate =>
  moment(utcCurrentDate()) < moment(timezoneDate(trialEndDate))
